import React from "react";

import clsx from "clsx";

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
  Trigger: React.ReactNode;
}

export const CustomNativeSelect: React.FC<Props> = props => {
  const { children, className, Trigger, value, ...select_attributes } = props;
  return (
    <div className={clsx("relative flex", className)}>
      {Trigger}
      <select
        data-testid="select-sorting"
        className="absolute left-0 top-0 h-full w-full cursor-pointer opacity-0"
        defaultValue={value}
        {...select_attributes}
      >
        {children}
      </select>
    </div>
  );
};
